var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-xc-page"},[_c('AboutHero'),_c('AboutIntro'),_c('PresidentMessage'),_c('HonorSection'),_c('MilestoneSection'),_c('CultureSection'),_c('TeamSection'),_c('SiteFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }